<template>
  <div class="contacts-page-home-by-phone">
      <woot-loading-state/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { frontendURL } from 'dashboard/helper/URLHelper';
import parsePhoneNumber from 'libphonenumber-js';

export default {
  props: {
    phone: { type: String, default: '' },
    name: { type: String, default: '' },
  },
  data() {
    return {      
    };
  },  
  computed: {
    ...mapGetters({
      currentAccountId: 'getCurrentAccountId',
      contacts: 'contacts/getContacts',
      getContactConversation: 'contactConversations/getContactConversation'
    })
  },
  watch: {      
  },
  async mounted() {
    const phone = this.phone.trim().replace(/\D/g, '');
    if(phone === '' || phone.length < 5){
      location.href = frontendURL(`accounts/${this.currentAccountId}/contacts`);      
      return;
    }    
    await this.$store.dispatch('contacts/search', {
      search: encodeURIComponent(phone),      
    });
    let contact;    
    if(this.contacts.length == 1){
      contact = this.contacts[0];
    }else if(this.contacts.length == 0){
      contact = await this.createContact();
    }
    let url_redirect = frontendURL(`accounts/${this.currentAccountId}/contacts`);
    if(contact){
      await this.$store.dispatch('contactConversations/get', contact.id);
      url_redirect = frontendURL(`accounts/${this.currentAccountId}/contacts/${contact.id}`);
      
      const conversation =  await this.getConvesationFromContact(contact);    
      if(conversation){
        url_redirect = frontendURL(`accounts/${this.currentAccountId}/conversations/${conversation.id}`);
      }    
    }    
    location.href = url_redirect;    
  },
  methods: {
    async getConvesationFromContact(contact) {      
      const conversations = await this.getContactConversation(contact.id).sort((a, b) => b.id - a.id);      
      if(conversations.length == 0) return null;
      const conversationPriority = conversations.find(c => c.status === 'open') || conversations.find(c => c.status === 'snoozed');
      return conversationPriority || conversations[0];
    },
    async createContact(){
      let phone = `+${this.phone.replace(/\D/g, '')}`;      
      let phoneWithDDIBR = `+55${this.phone.replace(/\D/g, '')}`;
      //prioridade para numero do Brasil
      let phoneBR = `${(phone.length >= 11 ? phone : phoneWithDDIBR)}`;
      if(!parsePhoneNumber(phoneBR) || !parsePhoneNumber(phoneBR).isValid()){        
        const phoneValidation = `${phoneBR.substring(0, 5)}9${phoneBR.substring(5)}`;
        if(!parsePhoneNumber(phoneValidation) || !parsePhoneNumber(phoneValidation).isValid()){
          phoneBR = null;
        }        
      }
      if(phoneBR === null && (!parsePhoneNumber(phone) || !parsePhoneNumber(phone).isValid())){
        return null;
      }else if(phoneBR){
        phone = phoneBR;
      }
      let name = this.name;
      if(!name){
        const numberParse = parsePhoneNumber(phone);
        let masked = phone.substring(0, 3) == '+55' ? numberParse.formatNational() : numberParse.formatNational().replace(/\D/g, "");
        const sub = masked.substring((numberParse.countryCallingCode == 55 ? 4 : 2), masked.length - 4);
        name = masked.replace(sub, '*'.repeat(sub.length)) || '';
      }
      try {        
        const response = await this.$store.dispatch('contacts/create', {
          name: name,
          phone_number: phone,
        });
        return response;
      } catch (error) {}
      return null;
    }
  },
};
</script>

<style lang="scss" scoped>
  .contacts-page-home-by-phone{
    width: 100%;
  }
</style>
